import { render, staticRenderFns } from "./videoSize.vue?vue&type=template&id=c2603d36&scoped=true&"
import script from "./videoSize.vue?vue&type=script&lang=js&"
export * from "./videoSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2603d36",
  null
  
)

export default component.exports